import { remoteApi } from './utils/constant'
import { post } from './utils/request'

export default {
  userInfo: ({ ...props }) =>
    post({
      url: remoteApi().webApi_userInfo,
      data: null,
      headers: {
        params: { ...props },
      },
    }),

  login: (data: any) =>
    post({
      url: remoteApi().webApi_login,
      data,
    }),

  judgeUserExist: (data: any, { ...props }) =>
    post({
      url: remoteApi().webApi_judgeUserExist,
      data,
      headers: {
        params: { ...props },
      },
    }),

  verify_code_image_create: ({ ...props }) =>
    post({
      url: remoteApi().webApi_verify_code_image_create,
      data: null,
      headers: {
        params: { ...props },
      },
    }),

  checkPhone: (data: any, { ...props }) =>
    post({
      url: remoteApi().webApi_checkPhone,
      data,
      headers: {
        params: { ...props },
      },
    }),

  checkEmail: (token: string, data: any, { ...props }) =>
    post({
      url: remoteApi().webApi_checkEmail,
      data,
      headers: {
        token,
        params: { ...props },
      },
    }),

  checkPassword: (token: string, data: any, { ...props }) =>
    post({
      url: remoteApi().webApi_checkPassword,
      data,
      headers: {
        token,
        params: { ...props },
      },
    }),

  forwardToEmail: (data: any, { ...props }) =>
    post({
      url: remoteApi().webApi_forwardToEmail,
      data,
      headers: {
        params: { ...props },
      },
    }),

  webApi_verify_code_create: (data: any, { ...props }) =>
    post({
      url: remoteApi().webApi_verify_code_create,
      data,
      headers: {
        params: { ...props },
      },
    }),

  register: (data: any, { ...props }) =>
    post({
      url: remoteApi().webApi_register,
      data,
      headers: {
        params: { ...props },
      },
    }),

  // user_bind: (data: any, { ...props }) =>
  //   post({
  //     url: remoteApi().webApi_user_bind,
  //     data,
  //     headers: {
  //       params: { ...props },
  //     },
  //   }),

  // user_unbind: (data, { ...props }) =>
  //   post({
  //     url: remoteApi().webApi_user_unbind,
  //     data,
  //     headers: {
  //       params: { ...props },
  //     },
  //   }),

  // user_get_third_part: (data, { ...props }) =>
  //   get({
  //     url: remoteApi().webApi_user_third_part_info,
  //     data,
  //     headers: {
  //       params: { ...props },
  //     },
  //   }),
}
